import { useState, useCallback } from 'react'
import { Dialog, DialogBody, DialogContent, DialogHeader, DialogTitle } from '@cutilei/ui'
import Cropper from 'react-easy-crop'
import getCroppedImg from '../../../services/Image'
import FileInput from '../../../components/Inputs/FileInput'

import {
  Container,
  Form,
  Image,
  SmallImage,
  CropContainer,
  RangeInput,
  Button,
  DangerButton,
  InfoText,
  ButtonText,
  ControlsContainer,
  ErrorContainer
} from './styles'

export default function AddPictureModal ({
  visible,
  title = 'Adicionar foto',
  onConfirm = () => null,
  onClose = () => null,
  currentImage
}) {
  const [imageSrc, setImageSrc] = useState (null)
  const [crop, setCrop] = useState ({ x: 0, y: 0 })
  const [zoom, setZoom] = useState (1)
  const [croppedAreaPixels, setCroppedAreaPixels] = useState (null)
  const [croppedImage, setCroppedImage] = useState (null)
  const [errorMessage, setErrorMessage] = useState (null)

  const handleCropComplete = useCallback ((_, croppedAreaPixels) => {
    setCroppedAreaPixels (croppedAreaPixels)
  }, [])

  const showCroppedImage = useCallback (async () => {
    try {
      const croppedImage = await getCroppedImg (imageSrc, croppedAreaPixels)
      setCroppedImage (croppedImage)
    } catch (error) {
      setErrorMessage ('Erro ao recortar imagem')
    }
  }, [imageSrc, croppedAreaPixels])

  const handleFileSelected = async file => {
    const fileUrl = await readFile (file)
    setImageSrc (fileUrl)
  }

  const readFile = file => {
    return new Promise (resolve => {
      const reader = new FileReader ()
      reader.addEventListener ('load', () => resolve (reader.result), false)
      reader.readAsDataURL (file)
    })
  }

  const handleSubmit = () => {
    onConfirm (croppedImage)
    handleClose ()
  }

  const handleClose = () => {
    setImageSrc (null)
    setCroppedAreaPixels (null)
    setCroppedImage (null)
    setErrorMessage (null)
    onClose ()
  }

  return (
    <Dialog open={visible} onOpenChange={open => { if (!open) handleClose() }}>
      <DialogContent size='md' closeOnOutsideClick={false} aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Form>
            {currentImage ? (
              <>
                <InfoText>Foto atual</InfoText>
                <SmallImage src={currentImage} alt='foto atual'/>
              </>
            ) : (
              <span style={{height: 10}}/>
            )}
            {!croppedImage && (
              <FileInput
                label={imageSrc ? 'Trocar imagem' : 'Selecionar imagem'}
                onFileSelected={handleFileSelected}
              />
            )}
            {imageSrc && !croppedImage && (
              <Container>
                <InfoText style={{marginTop: 10, marginBottom: 0}}>
                  Recorte a imagem
                </InfoText>
                <CropContainer>
                  <Cropper
                    image={imageSrc}
                    crop={crop}
                    zoom={zoom}
                    aspect={4 / 4}
                    onCropChange={setCrop}
                    onCropComplete={handleCropComplete}
                    onZoomChange={setZoom}
                  />
                </CropContainer>
                <ControlsContainer>
                  <InfoText>Zoom</InfoText>
                  <RangeInput
                    value={zoom}
                    aria-labelledby='Zoom'
                    min={1}
                    max={3}
                    step={0.1}
                    onChange={e => setZoom (Number(e.target.value))}
                  />
                </ControlsContainer>
                <Button onClick={showCroppedImage}>
                  Recortar e prosseguir
                </Button>
              </Container>
            )}
            {croppedImage && (
              <Container>
                <Image src={croppedImage.url}/>
                {errorMessage && (
                  <ErrorContainer>
                    <ButtonText>{errorMessage}</ButtonText>
                  </ErrorContainer>
                )}
                <Button onClick={handleSubmit}>
                  Confirmar
                </Button>
                <DangerButton onClick={() => setCroppedImage (null)}>
                  Descartar imagem
                </DangerButton>
              </Container>
            )}
          </Form>
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}
